import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { forecastersEndPointLogic } from '../logic/AssetManagement/Forecasters/forecastersEndPointLogic';
import { setDisplayErrorSnackBar } from '../features/userSlice';

const QUERY_ID = "5671636300726272";

export const usePastForecast = (modifiedRows: any, oauthTokenHeader: any, selectedSite: any) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false) as any;
  const [forecastData, setForecastData] = useState([]) as any;
  const ContentSharedUidCollection = modifiedRows.map(
    (row: any) => row.content_shared_uid
  );
  const DateCollection = modifiedRows.map((row: any) => row.month);

  useEffect(() => {
    const fetchAllForecastDeviations = async () => {
      try {
        setLoading(true);
        const promises = ContentSharedUidCollection.map((uid: any, index: any) =>
          forecastersEndPointLogic.getDeviationData(oauthTokenHeader,QUERY_ID,selectedSite,DateCollection[index],uid));
        const results = await Promise.all(promises);
        const enrichedResults = results.map((item, index) => ({
          ...item,
          content_shared_uid: ContentSharedUidCollection[index],
          month: DateCollection[index],
          displayMonth: modifiedRows[index].displayMonth,
        }));
        setForecastData(enrichedResults);
      } catch (error: any) {
        dispatch(setDisplayErrorSnackBar({ message: error.message, severity: "error", }));
      } finally {
        setLoading(false);
      }
    };
    if (ContentSharedUidCollection.length > 0) {
      fetchAllForecastDeviations();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return { forecastData, loading };
};

